export function initPlatformGrowth() {
  const section = document.querySelector('.section_platform-growth');
  if (!section) return;

  const h2 = section.querySelector('.platform-growth_h2');
  const subheading = section.querySelector('.platform-growth_subheading');
  const bgWrap = section.querySelector('.platform-bg_wrap');
  const bgImg2 = section.querySelector('.platform-bg_img.is--2');

  gsap.set(subheading, { opacity: 0, y: 24 });
  gsap.set(bgImg2, { opacity: 0 });

  const mm = gsap.matchMedia();

  mm.add(
    {
      isDesktop: '(min-width: 992px)',
      isMobile: '(max-width: 991px)',
    },
    (context) => {
      const { isDesktop } = context.conditions;
      const startSize = isDesktop ? 'calc(100% - 16rem)' : '90%';
      const endSize = isDesktop ? 'calc(100% + 8rem)' : '110%';
      const triggerStart = isDesktop ? 'top 30%' : 'top center';

      gsap.set(bgWrap, { width: startSize, height: startSize });

      const bgTl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: triggerStart,
          toggleActions: 'play none none reverse',
        },
      });

      bgTl.to(
        bgWrap,
        {
          width: endSize,
          height: endSize,
          duration: 2.4,
          ease: 'power2.in',
        },
        0
      );

      bgTl.to(
        bgImg2,
        {
          opacity: 1,
          duration: 1.2,
          ease: 'power2.out',
        },
        0
      );

      SplitText.create(h2, {
        type: 'lines,words',
        mask: 'lines',
        autoSplit: true,
        linesClass: 'platform-growth_h2_line',
        wordsClass: 'platform-growth_h2_word',
        onSplit(self) {
          gsap.set(self.words, { yPercent: 110, opacity: 0 });

          const textTl = gsap.timeline({
            scrollTrigger: {
              trigger: section,
              start: triggerStart,
              toggleActions: 'play none none none',
            },
          });

          textTl.to(
            self.words,
            {
              yPercent: 0,
              opacity: 1,
              duration: 0.8,
              ease: 'power3.out',
              stagger: 0.15,
            },
            0
          );

          textTl.to(
            subheading,
            {
              opacity: 1,
              y: 0,
              duration: 0.6,
              ease: 'power2.out',
            },
            '>-0.3'
          );

          return textTl;
        },
      });
    }
  );
}
